class VariantThumbnailUpdater {
      constructor() {
        this.attachOptionListeners()
        this.attachThumbnailClickListener()
        this.filterMediaVisibility(this.getActiveVariantId())
      }

      attachOptionListeners() {
        const inputs = '.product-form__input select, .product-form__input input[type="radio"], .product-form__input input[type="checkbox"]'
        document.querySelectorAll(inputs).forEach(i => {
          i.addEventListener('change', () => {
            setTimeout(() => {
              this.filterMediaVisibility(this.getActiveVariantId())
            }, 40) // ensure input is updated
          })
        })
      }

      attachThumbnailClickListener() {
        document.querySelectorAll('.product-thumbnail-wrapper[data-media-id]').forEach(thumb => {
          thumb.addEventListener('click', () => {
            document.querySelectorAll('.product-thumbnail.is-initial-selected')
              .forEach(el => el.classList.remove('is-initial-selected'))
            thumb.querySelector('.product-thumbnail').classList.add('is-initial-selected')
          })
        })
      }

      getActiveVariantId() {
        return document.querySelector('input[name="id"]')?.value
      }

    filterMediaVisibility(variantId) {
        if (!variantId) return

        const variantInput = document.querySelector('input[name="id"]')
        const contextEl = variantInput?.closest('.thb-product-detail')
          || document.querySelector('.thb-product-detail')
          || document

        const thumbsContainer = contextEl.querySelector('#Product-Thumbnails')
        const allMedia = thumbsContainer ? Array.from(thumbsContainer.querySelectorAll('.product-thumbnail-wrapper[data-media-id]')) : []
        const productSliderEl = contextEl.querySelector('product-slider')
        if (!productSliderEl) return

        const selectedVid = String(variantId).trim()

        const findSlide = (mid) =>
          productSliderEl.querySelector(`.product-images__slide[data-media-id="${mid}"]`)
          || productSliderEl.querySelector(`.product-images__slide[data-media-id$="-${mid}"]`)
          || productSliderEl.querySelector(`.product-images__slide[data-media-id*="${mid}"]`)
        const getFlk = () => productSliderEl.flkty || (typeof Flickity !== 'undefined' ? Flickity.data(productSliderEl) : null)
        const tailId = (raw) => (raw && raw.includes('-')) ? raw.split('-').pop() : raw

        // 1) Show/hide thumbnails and toggle classes
        allMedia.forEach(el => {
          const vid = String(el.dataset.variantId || '').trim()
          const thumb = el.querySelector('.product-thumbnail')
          const show = vid === selectedVid || vid === 'global'
          el.style.display = show ? 'block' : 'none'
          if (thumb) {
            thumb.classList.toggle('is-active', show)
            thumb.classList.toggle('is-selected', show)
            if (!show) thumb.classList.remove('is-initial-selected')
          }
        })

        // 2) Build deterministic visible order
        const visible = allMedia.filter(el => el.style.display !== 'none')
        const initThumb = thumbsContainer?.querySelector('.product-thumbnail.is-initial-selected') || null
        const initWrap = initThumb ? initThumb.closest('.product-thumbnail-wrapper[data-media-id]') : null
        const isVariant = el => String(el.dataset.variantId || '') === selectedVid
        const variantThumbs = visible.filter(isVariant)
        const globalThumbs = visible.filter(el => !isVariant(el))
        const preferred = (initWrap && initWrap.style.display !== 'none')
          ? initWrap
          : (variantThumbs[0] || visible[0] || null)
        const ordered = preferred
          ? [preferred, ...variantThumbs.filter(e => e !== preferred), ...globalThumbs.filter(e => e !== preferred)]
          : [...variantThumbs, ...globalThumbs]
        const visibleMediaIds = ordered.map(el => el.dataset.mediaId).filter(Boolean)

        // 3) Clear slide classes and reorder slides
        productSliderEl.querySelectorAll('.product-images__slide')
          .forEach(s => s.classList.remove('is-initial-selected', 'is-active'))
        const frag = document.createDocumentFragment()
        let firstSlide = null
        visibleMediaIds.forEach(mid => {
          const s = mid && findSlide(mid)
          if (!s) return
          frag.appendChild(s)
          s.classList.add('is-active')
          if (!firstSlide) firstSlide = s
        })
        if (frag.childNodes.length) productSliderEl.appendChild(frag)

        // 4) Re-init slider and select the first visible slide
        if (typeof productSliderEl.reInit === 'function') { try { productSliderEl.reInit() } catch (e) {} }
        if (firstSlide) {
          firstSlide.classList.add('is-initial-selected')
          if (typeof productSliderEl.selectCell === 'function' && firstSlide.id) {
            try { productSliderEl.selectCell(`#${firstSlide.id}`) } catch (e) {}
          } else {
            const flk = getFlk()
            if (flk && Array.isArray(flk.cells)) {
              const idx = flk.cells.findIndex(c => c.element === firstSlide)
              if (idx >= 0 && typeof flk.select === 'function') { try { flk.select(idx) } catch (e) {} }
            }
          }

          // Sync selected thumbnail to the chosen slide
          const chosenMediaId = tailId(firstSlide.dataset.mediaId || '')
          const chosenThumbWrapper = allMedia.find(el => el.dataset.mediaId === chosenMediaId && el.style.display !== 'none')
          thumbsContainer.querySelectorAll('.product-thumbnail.is-initial-selected').forEach(el => el.classList.remove('is-initial-selected'))
          chosenThumbWrapper.querySelector('.product-thumbnail')?.classList.add('is-initial-selected')
        }
    }
}

document.addEventListener('DOMContentLoaded', () => new VariantThumbnailUpdater())